import { SixdeeCRBTAPI } from '../../sixdeecrbtapi';
import { DeleteFromWishlistRequest } from './deletefromwishlistrequest';
import { HttpClient } from '../../../../utils/httpclient/httpclient';
import { BaseContext } from '../../../../utils/basecontext';
import { POST } from '../../api';

export class DeleteFromWishlistAPI extends SixdeeCRBTAPI<DeleteFromWishlistRequest>
{
    constructor(httpClient:HttpClient, appContext: BaseContext){
        super(httpClient, appContext);
    }

    getHttpMethod(){
        return POST;
    }

    getAPIURL(): string
    {
        // https://www.callertunes.etisalat.ae/Middleware/api/adapter/v1/crbt/delete-from-wishlist
        return "delete-from-wishlist";
    }

    getRequestData()
    {
        return "identifier="+ this.getRequest().getDeleteFromWishlistRequest().getIdentifier()+"&"+
               "msisdn="+ this.getRequest().getDeleteFromWishlistRequest().getMsisdn()+"&"+
               "catagoryId="+ this.getRequest().getDeleteFromWishlistRequest().getCatagoryId()+"&"+
               "language="+ this.getRequest().getDeleteFromWishlistRequest().getLanguage()+"&"+
               "clientTxnId=09062020&"+
               "wishlistType="+ this.getRequest().getDeleteFromWishlistRequest().getWishlistType();
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/api/wishlist/deletefromwishlist/deletefromwishlistapi.tsx